module.exports = __webpack_public_path__ + "static/media/FR-90.421714d8.geojson";